import { render, staticRenderFns } from "./BottomBlock.vue?vue&type=template&id=621e9fb5"
import script from "./BottomBlock.vue?vue&type=script&lang=js"
export * from "./BottomBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports